import { BannerDailyDeals } from 'components/main-page/home-page/daily-deals/banner-daily-deals/BannerDailyDeals'

export const BannerDailyDealsContainer = ({ dailyDealsDetail, onChangeForm, errorForm }) => {
    const copyItems = [...(dailyDealsDetail?.banners || [])]

    const setItems = (items) => {
        onChangeForm({ name: 'banners', value: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                image_url: null,
                url: null,
            },
        ])
    }

    const props = {
        items: copyItems,
        setItems,
        onChangeItem,
        onAddNewItem,
        errorForm,
    }

    return <BannerDailyDeals {...props} />
}
